import { useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { Drawer, Box, TextField, Button, Typography, InputAdornment, IconButton, Grid } from '@mui/material'
import { Visibility, VisibilityOff, InfoOutlined } from '@mui/icons-material'
import { backendHosts, apiUrl } from '../../../ui-utils/apiConfig'
import { httpRequest } from '../../../ui-utils/api'
import snackError from '../../../helpers/snackError'
import { reducerContext } from '../../../contextApi\'s/contextApi\'s'
// import handleLogout from '../../../helpers/handleLogout'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import axios from 'axios'

const textFieldStyles = {
    mb: 2,

    width: '190px !important',

    '& .MuiInputBase-root': {
        backgroundColor: '#131E2E !important',
        color: 'white !important',
        fontFamily: 'cardiuma-regular',
        fontSize: '16px'
    },

    '& .MuiInputLabel-root': {
        color: 'white !important',
        fontFamily: 'cardiuma-regular',
        fontSize: '14px',
    },

    '& .MuiInputBase-input': {
        color: 'white !important',
    },

    '& .MuiOutlinedInput-root': {
        '& fieldset': { borderColor: 'gray' },
    }
}

const ResetPassword = ({ open, onClose }) => {

    const { state, dispatch } = useContext(reducerContext)
    const navigate = useNavigate()

    const email = localStorage.getItem('email')

    const [oldPassword, setOldPassword] = useState('')
    const [newPassword, setNewPassword] = useState('')

    const [showPassword, setShowPassword] = useState(false)
    const [showNewPassword, setShowNewPassword] = useState(false)
    const [error, setError] = useState()

    const handleValueReset = () => {
        setOldPassword("")
        setNewPassword("")
        setError("")
        setShowPassword(false)
        setShowNewPassword(false)
    }

    const handleLogout = () => {
        localStorage.clear()
        dispatch({ type: 'SET_TOKEN_VAL', payload: '' })
        dispatch({ type: 'USER_SIGN_IN', payload: false });
        // dispatch({
        //     type: 'SET_SHOW_ERROR',
        //     payload: true
        // })

        // dispatch({
        //     type: 'SET_ERROR',
        //     payload: 'Unregistered successfully.'
        // })

        // dispatch({ type: 'SET_MY_SNACK', payload: snackError.mySucc })
        navigate("/")

    }

    const validate = () => {
        const isLocalOrStaging =
            window.location.hostname.includes("localhost") ||
            window.location.hostname.includes("staging")

        const passwordLength = isLocalOrStaging ? 4 : 6
        const regex = new RegExp(`^\\d{${passwordLength}}$`)

        if (!oldPassword || !newPassword) {
            setError("Please fill password fields")
            return false
        }

        if (!regex.test(oldPassword)) {
            setError(`Old Password must be a ${passwordLength}-digit number.`)
            return false;
        }


        if (!regex.test(newPassword)) {
            setError(`New Password must be a ${passwordLength}-digit number.`)
            return false;
        }

        if (oldPassword === newPassword) {
            setError("Old and New Passwords should not be the same.")
            return false;
        }

        setError("")
        return true
    }

    const handleReset = async () => {

        if (validate()) {

            const payload = {
                email,
                oldPassword: oldPassword,
                newPassword: newPassword,
            }

            console.log("Payload",payload)
            
            try {
                const passResponse = await axios.put(`${backendHosts.ADMIN}${apiUrl.resetPassword}`,payload)

                console.log("Reset Password Response",passResponse?.data?.data)

                if (passResponse?.data?.status == 200 && passResponse?.data?.data?.success) {

                    dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                    dispatch({ type: 'SET_ERROR', payload: passResponse?.data?.data?.message })
                    dispatch({ type: 'SET_MY_SNACK', payload: snackError.mySucc })

                    setTimeout(() => {
                        handleValueReset()
                        onClose()
                        handleLogout(dispatch, navigate)
                    }, 1000)

                } else {
                    dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                    dispatch({ type: 'SET_ERROR', payload: passResponse?.data?.data?.message })
                    dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                    console.log("Error in password reset API", error)
                }


            } catch (error) {
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: 'Error in password reset API' })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                console.log("Error in password reset API", error)
            }
        }

    }



    return (
        <Drawer anchor="right" open={open} onClose={() => {
            onClose()
            handleValueReset()
        }}>
            <Box sx={{
                width: 300,
                p: 2,
                backgroundColor: "#180D2B",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 2
            }}>



                <Grid container alignItems="center" justifyContent="end">

                    <Grid item>
                        <IconButton onClick={() => {
                            onClose()
                            handleValueReset()
                        }}>
                            <HighlightOffIcon sx={{ color: '#999' }} />
                        </IconButton>
                    </Grid>
                </Grid>

                <Typography sx={{
                    color: "white", fontFamily: 'cardiuma-M', fontSize: '18px', textAlign: 'center', mb: 2
                }}>Password Reset</Typography>

                <TextField
                    label="Email ID"
                    variant="outlined"
                    value={email}
                    size='small'
                    // disabled
                    sx={textFieldStyles}

                />

                <TextField
                    label="Old Password "
                    variant="outlined"
                    value={oldPassword}
                    onChange={e => {
                        const numericValue = e.target.value.replace(/\D/g, '')
                        setOldPassword(numericValue)
                    }}
                    type={showPassword ? 'text' : 'password'}
                    size="small"
                    inputMode='numeric'
                    pattern='[0-9]*'
                    sx={textFieldStyles}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment>
                                <IconButton
                                    onClick={() => setShowPassword((prev) => !prev)}
                                    edge="end"
                                    sx={{ color: 'white' }}
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />

                <TextField
                    label="New Password"
                    variant="outlined"
                    value={newPassword}

                    onChange={e => {
                        const numericValue = e.target.value.replace(/\D/g, '')
                        setNewPassword(numericValue)
                    }}

                    type={showNewPassword ? 'text' : 'password'}

                    size='small'
                    inputMode='numeric'
                    pattern='[0-9]*'
                    sx={textFieldStyles}

                    InputProps={{
                        endAdornment: (
                            <InputAdornment>
                                <IconButton
                                    onClick={() => setShowNewPassword((prev) => !prev)}
                                    edge="end"
                                    sx={{ color: 'white' }}
                                >
                                    {showNewPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />

                {error && (
                    <Typography color="error" sx={{
                        fontFamily: 'cardiuma-regular !important', fontSize: '14px', textAlign: 'center',
                    }}>
                        {error}
                    </Typography>
                )}

                <Box display="flex" alignItems="center">
                    <InfoOutlined fontSize="small" sx={{ color: "#999", mr: 1 }} />
                    <Typography sx={{ fontSize: {xs: '12px', sm: '13px'}, color: "#888" }}>
                        Once Reset password is successfull you will be logged out from the App.
                    </Typography>
                </Box>

                <Button
                    onClick={handleReset}
                    sx={{
                        width: 100,
                        height: 34,
                        backgroundColor: '#F44748',
                        color: '#fff',
                        fontFamily: 'cardiuma-regular',
                        fontSize: 11,
                        '&:hover': {
                            backgroundColor: '#F44748',
                        },
                    }}
                >
                    Submit
                </Button>
            </Box>
        </Drawer>
    )
}

export default ResetPassword
